/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABWklEQVR4nN2VO0sDQRDHrxDUxkrwA1gERD+AIFy76M0j4DpzWqQIBAsL0UJEEBsLC+1ECwtLsRXsxE8hKdIqgoKIhSDEByeX3CIa7o610IF/NcP8mNduEPxLI4qnkfQWWR5+0D2wXgHLIaKtFAYgyw6yvucRkD4DS1QaACx7QLLWEbJsIMs+sNxkMfoEoCOlADPVufHvYqy1g0h67kDWvQISS3zddpGeBr4Bxph+ZH37NQCirTgD3/YKCMOwD1hP0k1qM8toKQCQbAFLw9FS6m+lMUmLFnMn/wrAnjcgr0BSL5S8CACzDTozZmHI2wzCWm2AaH4CSY4ziFx4A7iGrEed2IjjqcA7ABWzdsmKd0DE8aTz8O16BwBJ3alg0ysgiuJhJGl2K6iq8XFoDSBdBpIDIH10tqiZXHdhAObTNaIdy5X8E4A6C6QvPX6xNpLeAeslkK4WOrI/Zx/c52evl4hMXwAAAABJRU5ErkJggg==)
 */
export const BIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M6.46 22a1 1 0 0 1-1-1V3.08a1 1 0 0 1 1-1h7.05c1.58 0 2.84.47 3.78 1.39a4.9 4.9 0 0 1 1.42 3.67 4.7 4.7 0 0 1-.81 2.85 4.64 4.64 0 0 1-2.02 1.59c2.46.62 3.7 2.25 3.7 4.9 0 1.9-.56 3.29-1.65 4.2-1.1.88-2.65 1.32-4.65 1.32H6.46Zm6.16-11.43a3.8 3.8 0 0 0 2.5-.75c.6-.5.9-1.26.9-2.28 0-1.02-.3-1.78-.9-2.28a3.7 3.7 0 0 0-2.5-.78H8.17v6.09h4.45Zm.6 9.03c1.12 0 2-.27 2.63-.8.65-.56.98-1.4.98-2.52 0-1.11-.33-1.94-.98-2.48a3.93 3.93 0 0 0-2.63-.8H8.17v6.6h5.05Z"
        className={colorClass}
      />
    </svg>
  );
};
